var Reflux = require('@muzzylane/reflux');
var ServerRequest = require('./request');
var ErrorConsts = require('../constants/error');
var ForgeError = require('../util/error');

var SubscriptionPlanActions = Reflux.createActions({
    "createPlan": {children: ["completed","failed"]},
    "getPlans": {children: ["started","completed","failed"]},           // for admins
    "getUpgradePlans": {children: ["started","completed","failed"]},    // for end users
    "getSubscriptionPlan": {children: ["completed","failed"]},          // for end users
    "getSubscriptionPlanForUser": {children: ["completed","failed"]},   // for end users
    "getOwnedOrgSubscriptions": {children: ["completed","failed"]},     // for end users
    "getProrateData": {children: ["completed","failed"]},               // for end users
    "changeSubscriptionPlan": {children: ["completed","failed"]},
    "changeSubscriptionStatus":  {children: ["completed","failed"]},
    "cancelSubscription": {children: ["completed","failed"]},
    "archivePlan": {children: ["completed","failed"]},
    "changePurchaseOrderPlan": {children: ["completed","failed"]},
});

SubscriptionPlanActions.createPlan.listen(function(actionID, params) {
    const self = this;

    ServerRequest.makeRequest('/authoring/ecommerce/create/plan', 'POST', JSON.stringify({
            account_type: params.account_type,
            display_name: params.display_name,
            token: params.token, // alphanumeric id for a plan, which we specify (i.e. 'individual-monthly')
            cost: params.cost, // this should be an integer. cost in "usd" pennies, i.e. 1000 = $10.00
            interval: params.interval, // this should be 'month', or 'year' (other values may be added in the future)
            pay_method: params.pay_method,
        }))
        .then(function(res) { self.completed(actionID, res, params) })
        .catch(function(err) { self.failed(actionID, err)})
});

SubscriptionPlanActions.getPlans.listen(function(actionID) {
    const self = this;

    self.started(actionID);
    ServerRequest.makeRequest('/authoring/ecommerce/plans', 'GET')
        .then(function(res) { self.completed(actionID, res) })
        .catch(function(err) { self.failed(actionID, err)})
});

SubscriptionPlanActions.getUpgradePlans.listen(function(actionID) {
    const self = this;

    self.started(actionID);
    ServerRequest.makeRequest('/authoring/ecommerce/upgrade_plans', 'GET')
        .then(function(res) { self.completed(actionID, res) })
        .catch(function(err) { self.failed(actionID, err)})
});

SubscriptionPlanActions.getSubscriptionPlan.listen(function(actionID) {
    const self = this;

    ServerRequest.makeRequest('/authoring/ecommerce/subscription_plan', 'GET')
        .then(function(res) { self.completed(actionID, res) })
        .catch(function(err) { self.failed(actionID, err)})
});

SubscriptionPlanActions.getSubscriptionPlanForUser.listen(function(actionID, params) {
    const self = this;

    if (!params.userId) {
        this.failed(actionID, new ForgeError({ message: ErrorConsts.MISSING_PARAMS }));
        return;
    }

    ServerRequest.makeRequest(`/authoring/ecommerce/subscription_plan_for_user/${params.userId}`, 'GET')
        .then(function(res) { self.completed(actionID, res) })
        .catch(function(err) { self.failed(actionID, err)})
});

SubscriptionPlanActions.getOwnedOrgSubscriptions.listen(function(actionID) {
    const self = this;
    ServerRequest.makeRequest('/authoring/ecommerce/owned_org_subscriptions', 'GET')
        .then(function(res) { self.completed(actionID, res) })
        .catch(function(err) { self.failed(actionID, err)})
});

SubscriptionPlanActions.getProrateData.listen(function(actionID) {
    const self = this;
    ServerRequest.makeRequest('/authoring/ecommerce/prorate_data', 'POST')
        .then(function(res) { self.completed(actionID, res) })
        .catch(function(err) { self.failed(actionID, err)})
});

SubscriptionPlanActions.archivePlan.listen(function(actionID, plan_id) {
    const self = this;
    ServerRequest.makeRequest('/authoring/ecommerce/archive/plan', 'POST', JSON.stringify({
        id: plan_id,
    }))
    .then(function(res) { self.completed(actionID, res) })
    .catch(function(err) { self.failed(actionID, err) })
});

SubscriptionPlanActions.changePurchaseOrderPlan.listen(function(actionID, org_user_id,plan_id) {
    const self = this;
    var params = {
        user_id: org_user_id,
        plan_id: plan_id,
    };
    ServerRequest.makeRequest('/authoring/ecommerce/change_po_plan', 'POST', JSON.stringify(params))
    .then(function(res) {
        self.completed(actionID, res, params);
    })
    .catch(function(err) { self.failed(actionID, err) })
});

SubscriptionPlanActions.changeSubscriptionPlan.listen(function(actionID, params) {
    const self = this;

    if (!params.plan_id || !params.success_url || !params.cancel_url) { 
        // may also have params.proration_date if they have an existing subscription
        this.failed(actionID, new ForgeError({ message: ErrorConsts.MISSING_PARAMS }));
        return;
    }

    return ServerRequest.makeRequest('/authoring/ecommerce/upgrade_account', 'POST', JSON.stringify(params))
    .then(function(res) { self.completed(actionID, res) })
    .catch(function(err) { self.failed(actionID, err) })
});

SubscriptionPlanActions.cancelSubscription.listen(function(actionID, params) {
    const self = this;

    if (!params.subscription_id) {
        this.failed(actionID, new ForgeError({ message: ErrorConsts.MISSING_PARAMS }));
        return;
    }

    ServerRequest.makeRequest('/authoring/ecommerce/cancel_subscription', 'POST', JSON.stringify(params))
    .then(function(res) { self.completed(actionID, res) })
    .catch(function(err) { self.failed(actionID, err) })
});

SubscriptionPlanActions.changeSubscriptionStatus.listen(function(actionID, params) {
    const self = this;

    if (!params.user_id || !params.status) {
        this.failed(actionID, new ForgeError({ message: ErrorConsts.MISSING_PARAMS }));
        return;
    }

    return ServerRequest.makeRequest('/authoring/ecommerce/change_po_subscription_status', 'POST', JSON.stringify(params))
    .then(function(res) { self.completed(actionID, res, params) })
    .catch(function(err) { self.failed(actionID, err) })
});


module.exports = SubscriptionPlanActions;
